
  import { hasSomePermission, Permissions } from '@/ui/auth/auth';
  import { Button } from '@/ui/components/Button';
  import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: {
      Button,
      EmptyStateEntry,
    },
    setup() {
      const canCreateIssue = () => hasSomePermission([Permissions.CREATE_ISSUE, Permissions.CREATE_ISSUE_WITH_ASSIGNEE]);

      return {
        canCreateIssue,
      };
    },
  });
